import bindAllOfThis from 'src/utils/BindThisHelper';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Rider, Seat } from '../objects/Rider';
import { EndGameScene } from './EndGameScene';

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;

    train: Phaser.GameObjects.Sprite;
    counter: Phaser.GameObjects.Text;
    count: number;

    riders: Rider[];
    seats: Seat[];

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
    }

    preload(): void {
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/ticket_taker.json"));
        this.load.image('background', require('/src/assets/qci/backgrounds/pke_background.png'));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameTicketTaker.png"), require("src/assets/qci/atlas/gameTicketTaker.json"));
    }

    initialize(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.riders = [];
        this.seats = [];
        this.count = 0;
    }

    create(): void {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0);
        this.createScene();
        this.createSeats();
        this.createRiders();
        this.registerEvents();
    }

    createScene() {
        this.map.getObjectLayer("Scene").objects.forEach((ob: TiledGameObject) => {
            if (ob.name === "train") {
                this.train = this.add.sprite(ob.x + ob.width / 2, ob.y + ob.height / 2, "assets", "train");
                var rails = this.add.image(0, 0, "assets", "rails").setOrigin(0);
            }
            else if (ob.name === "counter") {
                var style = { fontSize: 60, fontFamily: "Russo One", color: "#000000" };
                this.counter = this.add.text(ob.x + ob.width / 2, ob.y + ob.height / 2, this.count + "", style);
                // If we decide that the counter is necessary, we can show it
                this.counter.setVisible(false);
            }
        });
    }

    createSeats() {
        this.map.getObjectLayer("Seats").objects.forEach((ob: TiledGameObject) => {
            var seat = new Seat(this, ob);
            this.seats.push(seat);
        });
    }

    createRiders() {
        this.map.getObjectLayer("Riders").objects.forEach((ob: TiledGameObject) => {
            var rider = new Rider(this, ob);
            this.riders.push(rider);
        });
    }

    registerEvents(): void {
        this.input.dragDistanceThreshold = 10;

        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, rider: Rider) => {
            this.children.bringToTop(rider);
            pointer.x = rider.x;
            pointer.y = rider.y;
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, rider: Rider, dragX: number, dragY: number) => {
            rider.x = pointer.x;
            rider.y = pointer.y;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, rider: Rider, dropped: boolean) => {
            if (!dropped) {
                // Put back
                rider.x = rider.input.dragStartX;
                rider.y = rider.input.dragStartY;
            }
        });

        this.input.on('drop', (pointer: Phaser.Input.Pointer, helper: Rider, seat: Seat) => {
            this.drop(helper, seat);
        });
    }

    drop(rider: Rider, seat: Seat) {
        this.children.bringToTop(rider);

        rider.setFrame("passenger" + rider.id);
        rider.onTrain = true;
        rider.x = seat.x;
        rider.y = seat.y - 50;
        rider.input.enabled = false;
        seat.input.enabled = false;
        seat.occupied = true;
        rider.setDepth(0.9);

        this.count++;
        this.counter.setText(this.count + "");

        this.isGameOver();
    }

    isGameOver(): boolean {
        if (this.count !== 7) {
            return;
        }

        this.input.enabled = false;

        this.tweens.add({
            targets: [this.train, ...this.riders.filter((r: Rider) => r.onTrain)],
            x: "-=1000",
            duration: 3000,
            ease: "Linear",
            onComplete: () => {
                this.scene.add("EndGameScene", EndGameScene, true);
                this.scene.remove(this);
            }
        });

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/games/TicketTakerGame/scenes/MainScene.ts